module.exports = __webpack_public_path__ + "img/08.f7041806.png";